module.exports = __webpack_public_path__ + "static/media/arrow-top-right.aa5f1d2d.svg";